import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ToolIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M16.6 3a5 5 0 0 0-5.2 7c.2.4.1.9-.2 1.2L4.3 18A1.1 1.1 0 0 0 6 19.7l7-7a1 1 0 0 1 1-.1 5 5 0 0 0 7-5.2L18.5 10a2 2 0 0 1-2.8 0L14 8.4a2 2 0 0 1 0-2.8L16.6 3Zm-1.9-1.9a7 7 0 0 1 4.2.5 1 1 0 0 1 .3 1.6L15.4 7 17 8.6l3.8-3.8a1 1 0 0 1 1.6.3 7 7 0 0 1-8.6 9.5l-6.5 6.5A3.1 3.1 0 0 1 3 16.7l6.5-6.5a7 7 0 0 1 5.3-9Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default ToolIcon;
